import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { UserDeletionHistoryListSearchCriteria } from '../models/user-deletion-history.model';
import { UserDataChangesEndpoint } from '../constants/user-data-changes-endpoint';
import { UserDeletionHistoryStateModel } from './user-deletion-history.state';

@Injectable({
  providedIn: 'root',
})
export class UserDeletionHistoryService {
  constructor(private http: WrapperHttpService) {}

  getUserDeletionHistory(
    searchCriteria: UserDeletionHistoryListSearchCriteria,
  ): Observable<UserDeletionHistoryStateModel> {
    const url =
      `${API_URL}${UserDataChangesEndpoint.Base}${UserDataChangesEndpoint.PersonalData}${UserDataChangesEndpoint.Deleted}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<UserDeletionHistoryStateModel>(url);
  }
}
